import React from 'react'

function AlphaDSF() {
  return (
    <div className="hero bg-base-200 min-h-screen">
  <div className="hero-content flex-col lg:flex-row">
  <div className="card bg-base-100 w-96 shadow-xl">
        <figure>
            <img
            src="/sn.png"
            alt="Shoes" />
        </figure>
        <div className="card-body">
            <h2 className="card-title">
            Système Normal
            
            </h2>
            <p>La toute dernière version avec le fichier Excel DGI à jour autogénéré</p>
            <div className="card-actions justify-end">
           
            </div>
        </div>
    </div>
    <div className="card bg-base-100 w-96 shadow-xl">
        <figure>
            <img
            src="/smt.png"
            alt="Shoes" />
        </figure>
        <div className="card-body">
            <h2 className="card-title">
            Système Minimal
            
            </h2>
            <p>La toute dernière version avec le fichier Excel DGI à jour autogénéré</p>
            <div className="card-actions justify-end">
            
            </div>
        </div>
    </div>
    <div>
      <h1 className="text-5xl font-bold">Générez le format DGI de votre DSF !</h1>
      <p className="py-6">
      AlphaDSF monte la DSF, vérifie la cohérence et génère votre DSF au format Excel DGI sans aucun effort de votre part. En moins de 10 minutes, vous pouvez déjà la soumettre aux impôts.
      </p>
      <br />
        <h6>Appelez-nous ou écrire directement sur Whatsapp </h6>
      <br />
      <a className="btn btn-primary" href="https://wa.me/237699044427?text=Je%20veux%20le%20logiciel alphaDSF">Contact Whatsapp +237699044427<i className="icon ion-ios-arrow-forward icon-mobile"></i></a>
    </div>
  </div>
</div>
  )
}

export default AlphaDSF
